<template>
  <div>
    <c-tab
      type="horizon"
      :dense="true"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      :height="tabHeight"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :count="count"
          :contentHeight.sync="contentHeight"
          @changeStatus="changeStatus"
          @closePopup="closePopup"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
export default {
  name: 'education-curriculumn-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        eduCourseId: '',
        educationKindCdLarge: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'educationCurriculumInfo',
      tabItems: [],
      addTabItems: [],
      count: 0,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  methods: {
    init() {
      this.tabItems = [
        { name: 'educationCurriculumInfo', icon: 'info', label: '교육과정 기본정보', class:"tab-orange", component: () => import(`${'./educationCurriculumInfo.vue'}`) }
      ]
      this.addTabItems = [
        // { name: 'educationTargetUser', icon: 'face', label: '교육 대상자', component: () => import(`${'./educationTargetUser.vue'}`) },
        { name: 'educationHistory', icon: 'history', label: '교육과정별 교육계획 및 결과', component: () => import(`${'./educationHistory.vue'}`) },
        // { name: 'educationMaterial', icon: 'file_copy', label: '교육교재', component: () => import(`${'./educationMaterial.vue'}`) },
      ]
      if (this.popupParam.eduCourseId) {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    changeStatus() {
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
    tabClick() {
      this.count++;
    },
    closePopup() {
      this.$emit('closePopup')
    }
  }
};
</script>
